/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { FileDto } from './fileDto.schema';

export const ListOfFileDto = zod.array(zod.lazy(() => FileDto));

export type ListOfFileDto = zod.input<typeof ListOfFileDto>;
export type ListOfFileDtoOutput = zod.output<typeof ListOfFileDto>;
